import React from 'react';
import "./InputHelperText.scss";

const InputHelperText = ({text, children, valid, invalid}) => {
	return (
		<div className={`input-helper-text${valid ? " input-helper-text-valid" : ""}${invalid ? " input-helper-text-invalid" : ""}`}>{text || children}</div>
   );
}

export default InputHelperText;